<template>
    <div class="animated fade-in">
        <c-data-table
            class="my-4"
            :items="items"
            :fields="fields"
            :table-filter="true"
            :items-per-page="params.limit"
            items-per-page-select
            hover
            sorter
            :pagination="false"
            :sorterValue="params.sort"
            :tableFilterValue="params.filter"
            :loading="loading"
            @pagination-change="pageChange"
            @update:sorter-value="sortChange"
            @update:table-filter-value="filterChange"
            :clickableRows="clickable"
            @row-clicked="rowClick"
        >
            <template #email="{item}">
                <td>
                    <span v-if="item.user && item.user.email">{{ item.user.email }}</span>
                </td>
            </template>
            <template #type="{item}">
                <td>
                    <span v-if="item.type">{{ item.type.split('\\').pop() }}</span>
                </td>
            </template>
            <template #name="{item}">
                <td>
                    <span v-if="item.data && item.data.name">{{ item.data.name }}</span>
                </td>
            </template>
            <template #created_at="{item}">
                <td>
                    <span v-if="item.created_at">{{ item.created_at | moment("MMM D, YYYY, h:mm:ss a") }}</span>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <b-button-group>
                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="View"
                                  @click="viewNotification(item)">
                            <font-awesome-icon :icon="['fal','eye']"></font-awesome-icon>
                        </b-button>
                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="Re-Send"
                                  @click="resendNotification(item)">
                            <font-awesome-icon :icon="['fal','envelope']"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                </td>
            </template>
        </c-data-table>
        <c-pagination
                :active-page="params.page"
                :pages="Math.ceil(+(total/params.limit))"
                @update:activePage="updatePageNum"
        ></c-pagination>
        <c-modal scrollable :show.sync="show_preview" title="View Notification" size="lg">
            <b-overlay :show="loading_preview">
                <iframe frameborder="0" :src="preview_src" width="100%" height="600"></iframe>
            </b-overlay>
            <template #footer=""><span></span></template>
        </c-modal>
    </div>
</template>

<script>
  import Notification from "../../models/Notification";
  import User from "../../models/User";
  import ToastNotifications from "../shared/mixins/ToastNotifications";

  export default {
    name: 'NotificationTable',
    mixins: [ToastNotifications],
    props: ['refresh', 'type_whitelist', 'type_blacklist', 'show_fields', 'clickable'],
    data() {
      return {
        loading: true,
        notifications: [],
        items: [],
        fields: [
          {key: 'email', label: 'Email'},
          {key: 'type', label: 'Type'},
          {key: 'name', label: 'Name'},
          {key: 'created_at', label: 'Sent On'},
          {key: 'actions', label: 'Actions'},
        ].filter(field => { return !this.show_fields || this.show_fields.includes(field.key) }),
        total: null,
        params: {
          page: 1,
          limit: 20,
          sort: {column: 'created_at', asc: false},
          filter: null
        },
        loading_preview: true,
        show_preview: false,
        preview_src: null
      }
    },
    methods: {
      pageChange: function (val) {
        this.params.limit = val;
        this.fetchNotifications();
      },
      sortChange: function (val) {
        this.params.sort.column = val.column;
        this.params.sort.asc = val.asc;
        this.fetchNotifications();
      },
      filterChange: function (val) {
        this.params.filter = (val ? (val != '' ? val : null) : null);
        this.fetchNotifications();
      },
      updatePageNum: function (val) {
        this.params.page = val;
        this.fetchNotifications();
      },
      fetchNotifications: function () {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.params));
        if(this.type_whitelist && !this.type_blacklist) {
          params.type_whitelist = this.type_whitelist.join('|');
        } else if(!this.type_whitelist && this.type_blacklist) {
          params.type_blacklist = this.type_blacklist.join('|');
        }
        Notification.api().fetch(params).then((results) => {
          this.total = results.response.data.data.pagination.total;
          let notifications = results.entities.notifications;
          let ids = [];
          let user_ids = [];
          if(notifications) {
            notifications.forEach((notification) => {
              ids.push(notification.id);
              user_ids.push(notification.notifiable_id);
            });
          }
          User.api().fetch({id: user_ids.join('|'), limit: 999}).then(() => {
            this.notifications = Notification.query().whereIdIn(ids).with('user').get();
            this.items = this.notifications;
            this.loading = false;
          });
        });
      },
      rowClick(notification) {
        if(this.clickable) {
          this.viewNotification(notification);
        }
      },
      viewNotification(notification) {
        this.loading_preview = true;
        this.show_preview = true;
        Notification.api().view(notification.id).then((response) => {
          let data = response.response.data;
          this.preview_src = 'data:text/html;base64,' + btoa(unescape(encodeURIComponent(data)));
          let file = new Blob([data], {type: 'text/html'});
          let urlCreator = window.URL || window.webkitURL;
          let url = urlCreator.createObjectURL(file);
          this.preview_src = url;
          this.loading_preview = false;
        });
      },
      resendNotification(notification) {
        this.quickSuccessToast('Notification was re-sent', 'The message will reach them shortly.');
      }
    },
    watch: {
      refresh: function () {
        if (this.refresh) {
          this.$emit('onRefresh');
          this.fetchNotifications();
          this.$emit('onRefreshed');
        }
      },
    },
    created() {
      this.fetchNotifications();
    }
  }
</script>
